import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const FirstLineLeftColumn = styled(Box)`
  flex: 1;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const FirstLineRightColumn = styled(Box)`
  width: 45%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const SecondLineLeftColumn = styled(Box)`
  width: 35%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const SecondLineRightColumn = styled(Box)`
  flex-direction: column;
  flex: 1;

  @media (max-width: 1000px) {
    width: 100%;
  }
`
